import { createSlice } from "@reduxjs/toolkit";
import { CasterState } from "./types";

export const initialState: CasterState = {
  selectedConfig: {
    image: null,
    voice: null,
    gesture: false,
  },
};
export const casterSlice: any = createSlice({
  name: "caster",
  initialState,
  reducers: {
    // Define a reducer for updating the image field
    updateImage: (state, action) => {
      const { image } = action.payload;
      state.selectedConfig.image = image;
    },

    // Define a reducer for updating the voice field
    updateVoice: (state, action) => {
      const { voice } = action.payload;
      state.selectedConfig.voice = voice;
    },

    updateGesture: (state, action) => {
      const { gesture } = action.payload;
      state.selectedConfig.gesture = gesture;
    },

    nullConfig: (state) => {
      state.selectedConfig.image = "";
      state.selectedConfig.voice = "";
      state.selectedConfig.gesture = false;
    },
  },
});

export const { updateImage, updateVoice, updateGesture, nullConfig } = casterSlice.actions;
export default casterSlice.reducer;
